export default __webpack_public_path__ + "static/media/microscope.44b29704.png";